// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { PropTypes } from 'prop-types';
import {
  getCreateAccountPayload,
  getLoginPayload,
  getLearnMorePayload,
  getApplyNowPayload,
  getCustomLoyaltyLocation,
  setLoyaltyLocation,
} from '@tcp/core/src/constants/analytics';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import { getDynamicLabelValues } from '@tcp/core/src/utils/labels/labelUtilty.js';
import withStyles from '../../../../../../common/hoc/withStyles';
import Styles from '../styles/LoyaltyFooterSection.style';
import { routerPush } from '../../../../../../../utils';
import ApplyCardDynamicStore from '../../../../../browse/ApplyCardPage/container/ApplyCardDynamicStore';
import { getLabelFromCopyOrFromTranslation } from '../../../../../../../utils/labels/labelUtilty';
import {
  GlobalGenericLabels,
  GLOBAL_GENERIC_LABELS,
  lblLearnMore,
} from '../../../../../../../utils/labels/globalGeneric.labels';
import Button from '../../../../../../common/atoms/Button/index';
import {
  GlobalActionsLabels,
  GLOBAL_ACTIONS_LABELS,
  lblApplyNow,
} from '../../../../../../../utils/labels/globalActions.labels';

const openModalApplyNowModal = (openApplyNowModal, pageCategory, step = 1) => {
  if (!openApplyNowModal) return null;
  if (step === 1) return openApplyNowModal({ isModalOpen: true, status: null, pageCategory });
  return openApplyNowModal({
    isModalOpen: false,
    isPLCCModalOpen: true,
    status: null,
    pageCategory,
  });
};
// Helper functions accepting props
const getPLCCAppllyButton = (props) => {
  const {
    isPLCCApplyNowBtnAndLearnMoreBtnEnabled,
    isPLCCApplyNowBtnAndLearnMoreLinkEnabled,
    isPLCCApplyNowWithSaveBtnAndLearnMoreLinkEnabled,
  } = props;

  return (
    isPLCCApplyNowBtnAndLearnMoreBtnEnabled ||
    isPLCCApplyNowBtnAndLearnMoreLinkEnabled ||
    isPLCCApplyNowWithSaveBtnAndLearnMoreLinkEnabled
  );
};

const getPLCCLearnMoreButton = (props) => {
  const { isPLCCApplyNowBtnAndLearnMoreBtnEnabled } = props;
  return isPLCCApplyNowBtnAndLearnMoreBtnEnabled;
};

const showLearnMoreButton = (props) => {
  const {
    isPLCCApplyNowBtnAndLearnMoreBtnEnabled,
    isPLCCApplyNowBtnAndLearnMoreLinkEnabled,
    isPLCCApplyNowWithSaveBtnAndLearnMoreLinkEnabled,
  } = props;

  return !(
    isPLCCApplyNowBtnAndLearnMoreBtnEnabled ||
    isPLCCApplyNowBtnAndLearnMoreLinkEnabled ||
    isPLCCApplyNowWithSaveBtnAndLearnMoreLinkEnabled
  );
};

let loyaltyLocation = '';

const renderApplyNowLink = (
  text,
  closeAddedToBagModal,
  openApplyNowModal,
  pageCategory,
  isFancyBanner
) => {
  return (
    <Anchor
      useRouterNavigation={true}
      updateRoute={false}
      fontSizeVariation="medium"
      anchorVariation="primary"
      noLink
      className={`${isFancyBanner ? 'reward-apply-cta' : ''}`}
      handleLinkClick={async (e) => {
        e.preventDefault();
        await ApplyCardDynamicStore();
        openModalApplyNowModal(openApplyNowModal, pageCategory, 2);
        closeAddedToBagModal();
      }}
      underline
    >
      <ClickTracker
        onClick={() => {
          setLoyaltyLocation(loyaltyLocation);
        }}
        clickData={getApplyNowPayload(loyaltyLocation)}
      >
        {getLabelFromCopyOrFromTranslation(
          `${GLOBAL_ACTIONS_LABELS}.${lblApplyNow}`,
          GlobalActionsLabels
        )}
      </ClickTracker>
    </Anchor>
  );
};
const handleApplyNowClick = async ({
  e,
  closeAddedToBagModal,
  openApplyNowModal,
  pageCategory,
  step = 2,
}) => {
  e.preventDefault();
  await ApplyCardDynamicStore();
  openModalApplyNowModal(openApplyNowModal, pageCategory, step);
  closeAddedToBagModal();
};
const renderApplyNowButton = (
  text,
  closeAddedToBagModal,
  openApplyNowModal,
  pageCategory,
  props
) => {
  const { currentSubtotal, estimatedSubtotal, showSubtotal } = props;
  const applyNowButtonLabel = getDynamicLabelValues('dynamic.cart.lbl_cart_plcc_applynow_save');
  const savedAmount = (Number(currentSubtotal) - Number(estimatedSubtotal)).toFixed(2);

  const rewardsDesc = applyNowButtonLabel?.replace('#amount', `$${savedAmount}`);
  const label =
    props?.isPLCCApplyNowWithSaveBtnAndLearnMoreLinkEnabled && showSubtotal
      ? rewardsDesc
      : getLabelFromCopyOrFromTranslation(
          `${GLOBAL_ACTIONS_LABELS}.${lblApplyNow}`,
          GlobalActionsLabels
        );
  return (
    <Button
      onClick={(e) =>
        handleApplyNowClick({ e, closeAddedToBagModal, openApplyNowModal, pageCategory, step: 2 })
      }
      className={`coupon__button_black ${
        props?.isPLCCApplyNowWithSaveBtnAndLearnMoreLinkEnabled && showSubtotal ? 'applyNowXL' : ''
      } `}
      buttonVariation="variable-width"
      type="button"
      fullWidth={true}
      aria-labelledby="apply-now-button"
    >
      <ClickTracker
        onClick={() => {
          setLoyaltyLocation(loyaltyLocation);
        }}
        clickData={getApplyNowPayload(loyaltyLocation)}
      >
        {label}
      </ClickTracker>
    </Button>
  );
};

const renderLearnMoreButton = (text, closeAddedToBagModal, openApplyNowModal, pageCategory) => {
  return (
    <Button
      onClick={async (e) => {
        e.preventDefault();
        await ApplyCardDynamicStore();
        openModalApplyNowModal(openApplyNowModal, pageCategory, 1);
        closeAddedToBagModal();
      }}
      className={'coupon__button_white'}
      buttonVariation="variable-width"
      type="button"
      fullWidth={true}
      aria-labelledby="learn-more-button"
    >
      <ClickTracker
        onClick={() => {
          setLoyaltyLocation(loyaltyLocation);
        }}
        clickData={getLearnMorePayload(loyaltyLocation)}
      >
        {text}
      </ClickTracker>
    </Button>
  );
};

export const renderLearnMoreLink = (
  text,
  closeAddedToBagModal,
  openApplyNowModal,
  pageCategory,
  props
) => {
  const {
    isPLCCApplyNowBtnAndLearnMoreLinkEnabled,
    isPLCCApplyNowWithSaveBtnAndLearnMoreLinkEnabled,
  } = props;
  const showLinkInGrey =
    isPLCCApplyNowBtnAndLearnMoreLinkEnabled || isPLCCApplyNowWithSaveBtnAndLearnMoreLinkEnabled;
  return (
    <Anchor
      useRouterNavigation={true}
      updateRoute={false}
      fontSizeVariation="medium"
      anchorVariation="primary"
      noLink
      underline
      handleLinkClick={(e) =>
        handleApplyNowClick({ e, closeAddedToBagModal, openApplyNowModal, pageCategory, step: 1 })
      }
      className={showLinkInGrey ? 'greyLink' : null}
    >
      <ClickTracker
        onClick={() => {
          setLoyaltyLocation(loyaltyLocation);
        }}
        clickData={getLearnMorePayload(loyaltyLocation)}
      >
        {text}
      </ClickTracker>
    </Anchor>
  );
};

const onLinkClick = ({ e, componentId, closeAddedToBagModal, openOverlay, showFullPageAuth }) => {
  e.preventDefault();
  const { pathname = 'referrer' } = (window && window.location) || {};
  if (showFullPageAuth && componentId === 'createAccount') {
    routerPush(`/home?target=register&successtarget=${pathname}`, '/home/register');
  } else if (showFullPageAuth && componentId === 'login') {
    routerPush(`/home?target=login&successtarget=${pathname}`, '/home/login');
  } else {
    closeAddedToBagModal();
    openOverlay({
      component: componentId,
      variation: 'primary',
    });
  }
};

const renderCreateAccountLink = (text, closeAddedToBagModal, openOverlay, userInfo = {}) => {
  const { showFullPageAuth = false } = userInfo;

  return (
    text && (
      <Anchor
        fontSizeVariation="medium"
        anchorVariation="primary"
        noLink
        underline
        handleLinkClick={(e) => {
          e.preventDefault();
          onLinkClick({
            e,
            componentId: 'createAccount',
            closeAddedToBagModal,
            openOverlay,
            showFullPageAuth,
          });
        }}
      >
        <ClickTracker
          onClick={() => {
            setLoyaltyLocation(loyaltyLocation);
          }}
          clickData={getCreateAccountPayload(loyaltyLocation)}
        >
          {text}
        </ClickTracker>
      </Anchor>
    )
  );
};

const renderLoginLink = (text, closeAddedToBagModal, openOverlay, userInfo = {}) => {
  const { showFullPageAuth = false } = userInfo;
  return (
    <Anchor
      fontSizeVariation="medium"
      anchorVariation="primary"
      noLink
      underline
      handleLinkClick={(e) => {
        e.preventDefault();
        onLinkClick({
          e,
          componentId: 'login',
          closeAddedToBagModal,
          openOverlay,
          showFullPageAuth,
        });
      }}
    >
      <ClickTracker
        onClick={() => {
          setLoyaltyLocation(loyaltyLocation);
        }}
        clickData={getLoginPayload(loyaltyLocation)}
      >
        {text}
      </ClickTracker>
    </Anchor>
  );
};

const renderSpacer = (footerLabels, isFancyBanner) => {
  return (
    footerLabels.link1Action &&
    footerLabels.link2Action &&
    !isFancyBanner && <span className="space-between" />
  );
};

const getLinkWithName = (props, action, text) => {
  let returnLink;
  const {
    closeAddedToBagModal,
    openOverlay,
    openApplyNowModal,
    isPlcc,
    isGuest,
    showFullPageAuth,
    pageCategory,
    isRtpsFlow,
    isFancyBanner,
  } = props;
  loyaltyLocation = getCustomLoyaltyLocation(pageCategory, isRtpsFlow);
  switch (action) {
    case 'ApplyNowAction':
      returnLink = getPLCCAppllyButton(props)
        ? renderApplyNowButton(text, closeAddedToBagModal, openApplyNowModal, pageCategory, props)
        : renderApplyNowLink(
            text,
            closeAddedToBagModal,
            openApplyNowModal,
            pageCategory,
            isFancyBanner
          );
      break;
    case 'LearnMoreAction':
      if (getPLCCLearnMoreButton(props) && !isPlcc) {
        returnLink = renderLearnMoreButton(text, closeAddedToBagModal, openApplyNowModal);
      } else if (showLearnMoreButton(props)) {
        returnLink = renderLearnMoreLink(
          text,
          closeAddedToBagModal,
          openApplyNowModal,
          pageCategory,
          props
        );
      } else {
        returnLink = null;
      }
      break;
    case 'CreateAccountAction':
      returnLink = renderCreateAccountLink(text, closeAddedToBagModal, openOverlay, {
        isPlcc,
        isGuest,
        showFullPageAuth,
      });
      break;
    case 'loginAction':
      returnLink = renderLoginLink(text, closeAddedToBagModal, openOverlay, {
        isPlcc,
        isGuest,
        showFullPageAuth,
      });
      break;
    default:
      break;
  }
  return returnLink;
};

const renderLearnMore = (props, footerLabels) => {
  return (
    <>
      {footerLabels.link2Prefix && showLearnMoreButton(props) && (
        <BodyCopy
          className="symbolWrapper"
          color="text.primary"
          component="span"
          fontFamily="secondary"
          fontWeight="regular"
          fontSize="fs9"
        >
          {footerLabels.link2Prefix}
        </BodyCopy>
      )}
      {footerLabels.link2Action &&
        getLinkWithName(props, footerLabels.link2Action, footerLabels.link2Text)}
    </>
  );
};

const renderLearnMoreFancy = (props, footerLabels) => {
  return (
    <span className="reward-right-cta">
      {footerLabels.linkPrefix && showLearnMoreButton(props) && (
        <BodyCopy
          className="symbolWrapper"
          color="text.primary"
          component="span"
          fontFamily="secondary"
          fontWeight="regular"
          fontSize="fs9"
        >
          {footerLabels.linkPrefix}
        </BodyCopy>
      )}
      {footerLabels.link2Action &&
        getLinkWithName(props, footerLabels.link2Action, footerLabels.link2Text)}
    </span>
  );
};

const LoyaltyFooterSection = (props) => {
  const {
    className,
    footerLabels,
    pageCategory,
    isRtpsFlow,
    isFancyBanner,
    isPromoRedesignOnPDP,
    isPlcc,
  } = props;
  if (isPromoRedesignOnPDP) {
    return null;
  }
  loyaltyLocation = getCustomLoyaltyLocation(pageCategory, isRtpsFlow);
  const applyNowText = getLabelFromCopyOrFromTranslation(
    `${GLOBAL_ACTIONS_LABELS}.${lblApplyNow}`,
    GlobalActionsLabels
  );

  const learnMoreText = getLabelFromCopyOrFromTranslation(
    `${GLOBAL_GENERIC_LABELS}.${lblLearnMore}`,
    GlobalGenericLabels
  );
  footerLabels.link2Text = !isPlcc ? learnMoreText : '';
  return (
    <>
      {(applyNowText || learnMoreText) && (
        <div className={`${className} footer-wrapper`}>
          <div
            className={`links-wrapper ${
              props?.isPLCCApplyNowBtnAndLearnMoreBtnEnabled ? 'gap-8' : ''
            }`}
          >
            {footerLabels.link1Prefix && (
              <BodyCopy
                className="symbolWrapper"
                color="text.primary"
                component="span"
                fontFamily="secondary"
                fontWeight="regular"
                fontSize="fs9"
              >
                {applyNowText}
              </BodyCopy>
            )}
            {footerLabels.link1Action &&
              getLinkWithName(props, footerLabels.link1Action, footerLabels.link1Text)}
            {showLearnMoreButton(props) && renderSpacer(footerLabels, isFancyBanner)}
            {!isFancyBanner && renderLearnMore(props, footerLabels)}
            {isFancyBanner && renderLearnMoreFancy(props, footerLabels)}
          </div>
        </div>
      )}
    </>
  );
};

LoyaltyFooterSection.propTypes = {
  footerLabels: PropTypes.shape.isRequired,
  className: PropTypes.string,
  pageCategory: PropTypes.string,
  isRtpsFlow: PropTypes.bool,
  isFancyBanner: PropTypes.bool,
  isPromoRedesignOnPDP: PropTypes.bool,
};

LoyaltyFooterSection.defaultProps = {
  className: '',
  pageCategory: '',
  isRtpsFlow: false,
  isFancyBanner: false,
  isPromoRedesignOnPDP: false,
};

export default withStyles(LoyaltyFooterSection, Styles);
export { LoyaltyFooterSection as LoyaltyFooterSectionVanilla };
